
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getSelectedLangName } from '@/heplers';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import { KindMethodKeys } from '@/templates/NewRoutes';
import { LanguagesPack, SelectedLanguagesPack } from '@/store/types';
import { referencesMethod } from '@/templates/References';
import { parseAdvancedHrefHelper, parseHrefHelper } from '@/heplers/stringHelpers';

interface grpcObject {
  [grpc: string]: string;
}

@Component({
  components: {
    DocIcon,
  },
  filters: {
    parseHref: parseHrefHelper,
  },
})
export default class LegendOptions extends Vue {
  @Prop(Object) method: referencesMethod;
  @Getter('getSelectedLanguagesPack') languagesPack: SelectedLanguagesPack;

  get currentLanguage() {
    return this.languagesPack[<keyof LanguagesPack>getSelectedLangName(this.$route.meta.fqdn)];
  }

  get checkAllowedForCurrentLanguage() {
    if (this.method.attributes && this.method.attributes[this.currentLanguage] === false) {
      return false;
    }
    return true;
  }

  getTitle(title: string | grpcObject) {
    if (typeof title == 'object' && title.grpc) {
      return title.grpc;
    } else return title;
  }

  parseHrefByKind(fqdn: string, kind: any) {
    return parseAdvancedHrefHelper(fqdn, kind);
  }

  dataKindIcon(kind: string) {
    let dataKinds: string[] = Object.values(KindMethodKeys);
    return dataKinds.includes(kind);
  }
}
